import { getPasswordValidationError } from "./passwordValidation";
import {
  emailRegex,
  passwordRegex,
  nameRegex,
  projectNameRegex,
} from "./regex";
import validationMessages from "./validationMessages";
const fieldLabels = {
  name: "Name",
  email: "Email",
  baseCurrency: "Base Currency",
  signUpPassword: "Password",
  confirmPassword: "Confirm Password",
  customerName: "Name",
  startDate: "Start Date",
};

export const validateFormHandler = (values, fieldOptions = {}) => {
  const errors = {};

  for (const key in values) {
    if (!values.hasOwnProperty(key)) continue;

    const raw = values[key];
    const label = fieldLabels[key] || key;
    const value = typeof raw === "string" ? raw.trim() : raw;

    const isEmpty =
      value === null ||
      value === undefined ||
      (typeof value === "string" && value === "") ||
      (Array.isArray(value) && value.length === 0);

    // ✅ Generic Milestone Name Validation
    // ===============================
    // GENERIC MILESTONE NAME VALIDATION (Project rules)
    // ===============================
    if (key.startsWith("milestoneName_")) {
      const msgs = validationMessages.name;

      // Required
      if (!value || !value.trim()) {
        errors[key] = "Milestone name is required";
        continue;
      }

      // Too short
      if (value.length < 2) {
        errors[key] = msgs.tooShort;
        continue;
      }

      // Too long
      if (value.length > 30) {
        errors[key] = msgs.tooLong;
        continue;
      }

      // Trailing apostrophe / hyphen
      if (/['-]$/.test(value)) {
        errors[key] = msgs.trailingChar;
        continue;
      }

      // Same regex as Project Name
      if (!projectNameRegex.test(value)) {
        errors[key] = msgs.invalidProjectName;
        continue;
      }
    }

    // ✅ Generic Milestone Start Date Validation
    if (key.startsWith("milestoneStartDate_")) {
      if (!value) {
        errors[key] = "Milestone start date is required";
        continue;
      }
    }
    if (isEmpty) {
      errors[key] = validationMessages.required(label);
      continue;
    }

    // ✅ Person / Project Name Validation
    if (key === "name" || key === "customerName") {
      const context = fieldOptions[key] || "person";
      const isProject = context === "project";
      const regex = isProject ? projectNameRegex : nameRegex;
      const msgs = validationMessages.name;

      // 1️⃣ Too short
      if (value.length < 2) {
        errors[key] = msgs.tooShort;
        continue;
      }
      if (value.length > 30) {
        errors[key] = msgs.tooLong;
        continue;
      }
      // if (value.length > 20) {
      //   errors[key] = msgs.tooLong;
      //   continue;
      // }

      // 2️⃣ Trailing apostrophe or hyphen
      if (/['-]$/.test(value)) {
        errors[key] = msgs.trailingChar;
        continue;
      }

      // 3️⃣ Invalid characters
      if (!regex.test(value)) {
        errors[key] = isProject
          ? msgs.invalidProjectName
          : msgs.invalidPersonName;
        continue;
      }
    }
    // ✅ Email validation
    if (key === "email") {
      if (!emailRegex.test(value)) {
        errors[key] = validationMessages.email;
        continue;
      }
    }

    if (key === "signUpPassword") {
      const pwError = getPasswordValidationError(value, false);
      if (pwError) {
        errors[key] = Array.isArray(pwError) ? pwError.join(" ") : pwError;
        continue;
      }
    }

    // ✅ Numeric field checks
    if (
      (key === "amount" || key === "price") &&
      (isNaN(value) || Number(value) <= 0)
    ) {
      errors[key] = `${label} must be greater than 0`;
      continue;
    }
  }

  return errors;
};
export const validateLiveField = (key, value, fieldOptions = {}) => {
  const result = validateFormHandler({ [key]: value }, fieldOptions);
  return result[key] || null;
};
